let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2qEpG")).then(() => parcelRequire('d0bjG'));